import React from 'react';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { AuthenticationCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication/index.tsx';
import { withRouter, type RouteContext } from '@atlassian/react-resource-router';
import RouteWrapperEditPage from './ui/edit/index.tsx';

type Props = RouteContext;

const EditPage = (props: Props) => (
	<UFOSegment name="applinks-administration-edit-page">
		<AuthenticationCheck>
			<RouteWrapperEditPage id={props.match.params.applinkId ?? null} {...props} />
			<SpaStatePageReady />
		</AuthenticationCheck>
	</UFOSegment>
);

export default withRouter(EditPage);
